// extracted by mini-css-extract-plugin
export default {"container":"IntesivePage_container__nHHO0"};